import React from "react";
import { useParams } from "react-router-dom";
import CouponForm from "./CouponForm";
import BackDropFullScreen from "../../components/BackDropFullScreen";
import { useGetCouponById } from "../../queries/useCoupon";

function CouponEditPage() {
  const { couponId } = useParams<{ couponId: string }>();
  const { data: coupon, isLoading } = useGetCouponById(parseInt(couponId));

  return (
    <div>
      <CouponForm action={"EDIT"} coupon={coupon} />
      <BackDropFullScreen isOpen={isLoading} />
    </div>
  );
}

export default CouponEditPage;
